export default __webpack_public_path__ + "static/vacations-preview-spiritual-1-4692b7fc7325625da9717965ac7ae2b2.jpg";